import { SVGProps } from "react";

export default function CardsIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#757575", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.33594 8.40674H12.6693"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6693 6.85337V11.62C12.6493 13.52 12.1293 14 10.1493 14H3.85596C1.84262 14 1.33594 13.5 1.33594 11.5134V6.85337C1.33594 5.05337 1.75594 4.47337 3.33594 4.38003C3.49594 4.37337 3.66929 4.3667 3.85596 4.3667H10.1493C12.1626 4.3667 12.6693 4.8667 12.6693 6.85337Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6693 4.48667V9.14667C14.6693 10.9467 14.2493 11.5267 12.6693 11.62V6.85333C12.6693 4.86667 12.1626 4.36667 10.1493 4.36667H3.85596C3.66929 4.36667 3.49594 4.37333 3.33594 4.38C3.35594 2.48 3.87596 2 5.85596 2H12.1493C14.1626 2 14.6693 2.5 14.6693 4.48667Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 11.8733H4.64665"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07031 11.8733H8.36365"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
